<template>
    <div>
        <slot name="infoBar"></slot>
        <div class="m-checkList d-flex gap-1 flex-wrap" :class="[size]">
            <div
                class="custom-checkbox"
                style="white-space: nowrap"
                v-if="selectAll"
            >
                <the-btn
                    text="Zaznacz wszystkie"
                    class="btn-outline-custom d-none d-sm-inline-flex"
                    :class="{ 'd-inline-flex': !allowSelectAll }"
                    icon="CheckCorrect"
                    @click.native="selectAll(true)"
                />
                <the-btn
                    text="Odznacz wszystkie"
                    class="
                            btn-danger
                            ml-sm-2
                            d-none d-sm-inline-flex
                        "
                    :class="{ 'd-inline-flex': allowSelectAll }"
                    icon="CheckIncorrect"
                    @click.native="selectAll(false)"
                />
            </div>
            <slot></slot>
        </div>
        <div class="m-checkList__rows scrollbar" :class="[size]">
            <check-list-row
                v-for="row in list"
                :key="row.id"
                :row="row"
                :select-row="selectRow"
                :selected-rows="selectedRows"
                :disabled="isDisabled(row.id)"
                :type="type"
            >
                <template #rowDetails="{ row }">
                    <slot name="rowDetails" :row="row" />
                </template>
            </check-list-row>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        list: {
            type: Array,
            required: true
        },
        selectAll: {
            type: Function
        },
        selectRow: {
            type: Function,
            default: () => {}
        },
        selectedRows: {
            type: Array,
            default: () => []
        },
        rowInfo: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'checkbox'
        },
        disabledRows: {
            type: Array,
            default: () => []
        },
        size: {
            type: String,
            default: 'medium',
            validator: (value) => ['small', 'medium', 'large'].includes(value)
        }
    },
    computed: {
        allowSelectAll() {
            return this.list.length === this.selectedRows.length
        }
    },
    methods: {
        isDisabled(id) {
            return this.disabledRows?.includes(id)
        }
    }
}
</script>
